export const generateRandomInteger = (min = 1, max = 9, digit = 10): number => {
  const rand = min + Math.random() * (max + 1 - min);

  return Math.floor(rand * 10 ** digit);
};
